import electricIcon from '../../../images/icons/category-icons/electric-guitars.png';
import acousticIcon from '../../../images/icons/category-icons/acoustic-guitars.png';
import bassIcon from '../../../images/icons/category-icons/bass-guitars.png';
import ampsIcon from '../../../images/icons/category-icons/amps.png';
import effectsIcon from '../../../images/icons/category-icons/effects-and-pedals.png';
import percussionIcon from '../../../images/icons/category-icons/drums-and-percussion.png';
import proAudioIcon from '../../../images/icons/category-icons/pro-audio.png';
import keyboardsIcon from '../../../images/icons/category-icons/keyboards-and-synths.png';
import djIcon from '../../../images/icons/category-icons/dj-and-lighting-gear.png';
import folkIcon from '../../../images/icons/category-icons/folk-instruments.png';
import bandIcon from '../../../images/icons/category-icons/band-and-orchestra.png';
import softwareIcon from '../../../images/icons/category-icons/software.png';
import homeAudioIcon from '../../../images/icons/category-icons/home-audio.png';
import accessoriesIcon from '../../../images/icons/category-icons/accessories.png';
import partsIcon from '../../../images/icons/category-icons/parts.png';

export interface CategoryConfig {
  slug: string;
  uuid: string;
  image: string;
  image_v2: string;
  icon: string;
}

const categories: CategoryConfig[] = [
  {
    slug: 'electric-guitars',
    uuid: 'dfd39027-d134-4353-b9e4-57dc6be791b9',
    image: 'https://images.reverb.com/image/upload/s--6lsmaC9l--/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1517439840/kkzmwdlhm4abwkaqm2yx.jpg',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1588713734/1-Electric-Guitars_so8uof.jpg',
    icon: electricIcon,
  },
  {
    slug: 'acoustic-guitars',
    uuid: '3ca3eb03-7eac-477d-b253-15ce603d2550',
    image: 'https://images.reverb.com/image/upload/s--QxeTrLv---/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1517439887/hdlilnvpoamssgjgobu2.jpg',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1588713734/3-Acoustic_zwfdsz.jpg',
    icon: acousticIcon,
  },
  {
    slug: 'bass-guitars',
    uuid: '53a9c7d7-d73d-4e7f-905c-553503e50a90',
    image: 'https://images.reverb.com/image/upload/s--w3RH7La0--/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1517524187/mlavmt96l9sk0jw2cbxk.jpg',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1588713735/7-Bass_pnpd7m.jpg',
    icon: bassIcon,
  },
  {
    slug: 'amps',
    uuid: '09055aa7-ed49-459d-9452-aa959f288dc2',
    image: 'https://images.reverb.com/image/upload/s--QCJao-24--/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1517516932/g7iya2pwhgsmjvbj4lly.jpg',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1588713735/4-Amps_ssbqna.jpg',
    icon: ampsIcon,
  },
  {
    slug: 'effects-and-pedals',
    uuid: 'fa10f97c-dd98-4a8f-933b-8cb55eb653dd',
    image: 'https://images.reverb.com/image/upload/s--woREDgNs--/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1517515117/tvje25dlsv0h74xtdmxi.jpg',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1588713734/5-Effects_gmynv4.jpg',
    icon: effectsIcon,
  },
  {
    slug: 'drums-and-percussion',
    uuid: 'b3cb9f8e-4cb6-4325-8215-1efcd9999daf',
    image: 'https://images.reverb.com/image/upload/s--7jxP5Jg---/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1517515062/eh6f63wg6s6ohbhc1n6t.jpg',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1588713734/6-Drums_pzx7ot.jpg',
    icon: percussionIcon,
  },
  {
    slug: 'pro-audio',
    uuid: 'b021203f-1ed8-476c-a8fc-32d4e3b0ef9e',
    image: 'https://images.reverb.com/image/upload/s--xR_917J---/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1435077894/ysvhfqmuhefale42jbod.jpg',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1588713736/8-Pro-Audio_dtwt0k.jpg',
    icon: proAudioIcon,
  },
  {
    slug: 'keyboards-and-synths',
    uuid: 'd002db05-ab63-4c79-999c-d49bbe8d7739',
    image: 'https://images.reverb.com/image/upload/s--xXIfpFXp--/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1517514830/a2o8edcctbcviktpzzbv.jpg',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1588713734/2-Synths_fagrao.jpg',
    icon: keyboardsIcon,
  },
  {
    slug: 'dj-and-lighting-gear',
    uuid: '58d889f7-0aa1-4689-a9d3-da16dd225e8d',
    image: 'https://images.reverb.com/image/upload/s--80gjCA29--/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1517514888/qudsayedfpnmhdlcyuvx.jpg',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1588713735/9-DJ_blup7h.jpg',
    icon: djIcon,
  },
  {
    slug: 'folk-instruments',
    uuid: 'fb60628c-be4b-4be2-9c0f-bc5d31e3996c',
    image: 'https://images.reverb.com/image/upload/s--Qv_qjY4h--/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1517514685/o8kfxqk4mfjq9eydhcju.jpg',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1589218633/10-Folk_t6pdn3.jpg',
    icon: folkIcon,
  },
  {
    slug: 'band-and-orchestra',
    uuid: '032c74d0-b0e2-4442-877f-e1a22438a7fa',
    image: 'https://images.reverb.com/image/upload/s--MAzROclG--/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1517523491/m1pymkdgtmhbfu1w1wra.jpg',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1588713735/11-B_O_uyl4vn.jpg',
    icon: bandIcon,
  },
  {
    slug: 'software',
    uuid: 'e71b6e43-7217-4746-b4e3-64bf708a2664',
    image: 'https://images.reverb.com/image/upload/s--LnbFMnuE--/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1467919857/drfec9qp8jpepbfqyj3f.png',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1588713735/12-Software_gw56il.jpg',
    icon: softwareIcon,
  },
  {
    slug: 'home-audio',
    uuid: '40e8bfd0-3021-43f7-b104-9d7b19af5c2b',
    image: 'https://images.reverb.com/image/upload/s--4U9eJ0ym--/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1517515006/tn7nx3xqo74lovw6bcmx.jpg',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1588713736/13-HomeAudio_rz2vs9.jpg',
    icon: homeAudioIcon,
  },
  {
    slug: 'accessories',
    uuid: '62835d2e-ac92-41fc-9b8d-4aba8c1c25d5',
    image: 'https://images.reverb.com/image/upload/s--tunY4ZL_--/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1517524228/opcf4u8vzg9ijfqyptxr.jpg',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1588713736/13-Accessories_v2xyxm.jpg',
    icon: accessoriesIcon,
  },
  {
    slug: 'parts',
    uuid: '1f99c852-9d20-4fd3-a903-91da9c805a5e',
    image: 'https://images.reverb.com/image/upload/s--7UE8iBDc--/a_exif,c_limit,f_auto,fl_progressive,g_south,h_1136,q_auto:eco,w_640/v1509486470/lqomczdvxsbts5lfwpzy.png',
    image_v2: 'https://reverb-res.cloudinary.com/image/upload/v1588713736/14-Parts_e47wbg.jpg',
    icon: partsIcon,
  },
];

export const categoryForSlug = (slug: string) => categories.find(c => c.slug === slug);

export default categories;
